import React, { useState, useContext, useEffect } from "react";

import { makeStyles } from "@material-ui/core/styles";
import { Create, DeleteForever, AddCircle } from "@material-ui/icons";
import ModalUsuarios from "../ModalUsuarios/ModalUsuarios";
import {
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableBody,
  IconButton,
  Box,
} from "@material-ui/core";
import UsuarioContext from "../../Context/Usuario/UsuarioContext";
import AuthContext from "../../Context/auth/AuthContext";

//simulacion de la base de datos filas

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: "440",
  },
  paper: {
    position: "absolute",
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  align: {
    width: "100%",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

const Tabla = () => {
  //extrayendo valores del context
  const {
    columns,
    usuarios,
    onChangeUsuarioActivo,
    obtenerUsuarios,
    removerUsuario,
  } = useContext(UsuarioContext);
  const { cuenta } = useContext(AuthContext);

  const clases = useStyles();

  //define si el modal seabre o no
  const [open, setopen] = useState(false);
  //datos de la empresa que se selcciona

  //funcion que abre el modal
  const handleOpen = () => {
    setopen(true);
  };

  //funcion que cierrra el modal
  const handleClose = () => {
    //cuando se cierra el modal restablecer los valores de la empresa activa
    onChangeUsuarioActivo({
      codEmpresa: "",
      nombres: "",
      userName: "",
      email: "",
      password: "",
      rol: "usuario",
      estado: "ACTIVO",
    });
    setopen(false);
  };

  const infoEmpresa = (id) => {
    //cuando se le da click a una empresa para editar
    //colocar los valores de esa empresa en el state
    const informacion = usuarios.filter((fila) => fila._id === id);

    onChangeUsuarioActivo(informacion[0]);
  };

  //paginacion de la tabla
  const [pagina, setpagina] = useState(0);
  const [filasPorPagina, setfilasPorPagina] = useState(5);

  //pagina en la que te encuentras en la tabla
  const handleChangePage = (e, nuevaPagina) => {
    setpagina(nuevaPagina);
  };
  //cambiando el numero de  filas por pagina
  const handleChangeRowsPerPage = (e) => {
    setfilasPorPagina(+e.target.value);
    setpagina(0);
  };

  useEffect(() => {
    if (!usuarios) {
      //obteniendo los usuarios
      obtenerUsuarios();
    }
  }, [usuarios, obtenerUsuarios]);


  if (!usuarios) return null;
  return (
    <Paper className={clases.root}>
      {cuenta.rol === "usuario" ? null : (
        <Box display="flex" flexDirection="row-reverse">
          <IconButton
            aria-label=""
            onClick={() => {
              handleOpen();
            }}
          >
            <AddCircle />
          </IconButton>
        </Box>
      )}
      {/* cuerpo  del modal */}
      <ModalUsuarios open={open} handleClose={handleClose} />

      {/* inicio de la tabla */}
      <TableContainer className={clases.container}>
        <Table stickyHeader aria-label="sticky table" id="tablaUsuarios" size="small">
          <TableHead>
            <TableRow>
              {/* recorriendo el encabezado */}
              {columns.map((columna, index) => (
                <TableCell
                  key={columna.id}
                  align={columna.align}
                  style={{ minWidth: columna.minWidth }}
                >
                  {columna.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {/* //recorriendo las filas */}
            {usuarios
              .slice(
                pagina * filasPorPagina,
                pagina * filasPorPagina + filasPorPagina
              )
              .map((fila, index) => {
                if (
                  fila.empresa !== cuenta.empresa &&
                  cuenta.rol === "usuario"
                ) {
                  return null;
                }
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={fila._id}>
                    {columns.map((columna, index, a) => {
                      const value = fila[columna.id];
                      let Borrar = (
                        <IconButton
                          aria-label=""
                          onClick={() => removerUsuario(fila._id)}
                        >
                          {" "}
                          <DeleteForever />
                        </IconButton>
                      );
                      if (cuenta.rol === "usuario") {
                        Borrar = null;
                      }

                      if (
                        index === 7 &&
                        cuenta.rol === "usuario" &&
                        fila.email !== cuenta.email
                      ) {
                        return null;
                      }
                      return (
                        <TableCell key={columna.id} align={columna.align}>
                          {/* creando un ternario para colocar los botones en la tabla */}
                          {value === "Create" ? (
                            <>
                              <Box display="flex" justifyContent="space-between">
                                <IconButton
                                  aria-label=""
                                  onClick={() => {
                                    //funcion que coloca la informacion en el state para editar la empresa seleccionada
                                    infoEmpresa(fila._id);
                                    //funcion que abre el modal
                                    handleOpen();
                                  }}
                                >
                                  <Create />
                                </IconButton>

                                {Borrar}
                              </Box>
                            </>
                          ) : (
                            value
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
        {/* pie de la tabla  */}
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 20, 25, 50, 100]}
        component="div"
        count={usuarios.length}
        rowsPerPage={filasPorPagina}
        page={pagina}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default Tabla;
